import { render, staticRenderFns } from "./ConsultasDetalheEsclarecimentoImpugnacao.vue?vue&type=template&id=1c2698e6&scoped=true"
import script from "./ConsultasDetalheEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./ConsultasDetalheEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./ConsultasDetalheEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=1c2698e6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2698e6",
  null
  
)

export default component.exports